import { Link } from 'react-router-dom';
import { ArrowLeft, Calendar, Gift, Palette, Gamepad2 } from 'lucide-react';

export default function ArtikelRamadanAktivitaetenKinder() {
  return (
    <main className="pt-20 md:pt-24 bg-[#FDFCF8]">
      <section className="py-16 md:py-24 bg-[#4A5D4F]">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <Link to="/ratgeber" className="inline-flex items-center gap-2 text-white/80 hover:text-white mb-8 transition-colors"><ArrowLeft className="w-4 h-4" />Alle Ratgeber</Link>
          <div className="flex items-center gap-2 text-[#D4C5A9] text-sm mb-4"><Calendar className="w-4 h-4" /><span>Februar 2026</span></div>
          <h1 className="font-serif text-3xl md:text-4xl lg:text-5xl font-medium text-white mb-6 leading-tight">Ramadan Aktivitäten für Kinder: Spielideen und Basteln</h1>
          <p className="text-lg text-white/80 leading-relaxed">30 kreative Ideen, um Kindern den Ramadan spielerisch näherzubringen.</p>
        </div>
      </section>
      <article className="py-16 md:py-20">
        <div className="max-w-3xl mx-auto px-6 md:px-12 prose prose-lg max-w-none">
          <p className="text-xl text-[#2C332E] leading-relaxed mb-8">Der Ramadan ist eine wunderbare Gelegenheit, Kindern islamische Werte spielerisch zu vermitteln. Mit den richtigen Aktivitäten wird der Fastenmonat zu einem unvergesslichen Erlebnis für die ganze Familie.</p>

          <div className="bg-[#F5F5F0] rounded-2xl p-6 md:p-8 mb-12">
            <h2 className="font-serif text-xl font-medium text-[#2C332E] mb-4">📖 Kategorien</h2>
            <ul className="space-y-2 text-[#4A5D4F]">
              <li><a href="#basteln" className="hover:underline">1. Bastel-Aktivitäten</a></li>
              <li><a href="#spiele" className="hover:underline">2. Spiele & Quiz</a></li>
              <li><a href="#kochen" className="hover:underline">3. Gemeinsam Kochen</a></li>
              <li><a href="#lesen" className="hover:underline">4. Vorlesen & Lernen</a></li>
              <li><a href="#gutes" className="hover:underline">5. Gute Taten</a></li>
            </ul>
          </div>

          <section id="basteln" className="mb-12">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 rounded-full bg-[#D4C5A9]/30 flex items-center justify-center"><Palette className="w-6 h-6 text-[#4A5D4F]" /></div>
              <h2 className="font-serif text-2xl font-medium text-[#2C332E]">1. Bastel-Aktivitäten</h2>
            </div>
            <div className="space-y-4">
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">🌙 Mond- und Stern-Girlande</h4>
                <p className="text-sm text-[#4B5563]">Aus Goldpapier Monde und Sterne ausschneiden und an einer Schnur aufhängen. Perfekte Ramadan-Deko!</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">🏮 Papierlaternen</h4>
                <p className="text-sm text-[#4B5563]">Bunte Laternen aus Papier basteln und mit LED-Teelichtern beleuchten.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">💌 Eid-Karten gestalten</h4>
                <p className="text-sm text-[#4B5563]">Mit Stempeln, Glitzer und Aufklebern personalisierte Grußkarten erstellen.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">📅 Ramadan-Kalender basteln</h4>
                <p className="text-sm text-[#4B5563]">30 kleine Tüten oder Boxen mit Überraschungen und guten Taten füllen.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">🕌 Moschee aus Karton</h4>
                <p className="text-sm text-[#4B5563]">Eine Moschee aus Schuhkartons und Papprollen bauen und anmalen.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">🎨 Islamische Muster malen</h4>
                <p className="text-sm text-[#4B5563]">Geometrische Muster und Arabesken auf Papier oder Stofftaschen malen.</p>
              </div>
            </div>
          </section>

          <section id="spiele" className="mb-12">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 rounded-full bg-[#4A5D4F]/10 flex items-center justify-center"><Gamepad2 className="w-6 h-6 text-[#4A5D4F]" /></div>
              <h2 className="font-serif text-2xl font-medium text-[#2C332E]">2. Spiele & Quiz</h2>
            </div>
            <div className="space-y-4">
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">❓ Ramadan-Quiz</h4>
                <p className="text-sm text-[#4B5563]">Fragen über Ramadan, Eid und den Islam – wer die meisten richtig beantwortet, gewinnt!</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">🃏 SIRA-Kartenspiel</h4>
                <p className="text-sm text-[#4B5563]">Quizkarten über das Leben des Propheten – lehrreich und unterhaltsam.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">🧠 Islamisches Memory</h4>
                <p className="text-sm text-[#4B5563]">Karten mit islamischen Motiven (Moschee, Mond, Stern, Quran) selbst gestalten.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">🎯 Schatzsuche</h4>
                <p className="text-sm text-[#4B5563]">Ramadan-Schatzsuche mit Hinweisen zu islamischen Themen durchs Haus.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">🌍 Weltreise zum Iftar</h4>
                <p className="text-sm text-[#4B5563]">Jeden Tag ein anderes Land kennenlernen und dessen Iftar-Gericht probieren.</p>
              </div>
            </div>
          </section>

          <section id="kochen" className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">3. Gemeinsam Kochen</h2>
            <div className="space-y-4">
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">🍪 Eid-Kekse backen</h4>
                <p className="text-sm text-[#4B5563]">Kekse in Mond- und Sternform ausstechen und dekorieren.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">🥤 Getränke für Iftar</h4>
                <p className="text-sm text-[#4B5563]">Kinder können Limonade oder Smoothies für die Familie zubereiten.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">🍫 Dattel-Trüffel rollen</h4>
                <p className="text-sm text-[#4B5563]">Einfaches Rezept – Datteln, Nüsse und Kokos – auch für kleine Hände.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">🍽️ Tisch decken helfen</h4>
                <p className="text-sm text-[#4B5563]">Kinder lernen, den Iftar-Tisch festlich zu decken und zu dekorieren.</p>
              </div>
            </div>
          </section>

          <section id="lesen" className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">4. Vorlesen & Lernen</h2>
            <div className="space-y-4">
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">📖 Tägliche Ramadan-Geschichte</h4>
                <p className="text-sm text-[#4B5563]">Jeden Abend eine kurze Geschichte über Propheten oder islamische Werte.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">🤲 Ein Dua pro Tag lernen</h4>
                <p className="text-sm text-[#4B5563]">Kurze Duas wie vor dem Essen, nach dem Aufwachen oder vor dem Schlafen.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">🔤 Arabische Buchstaben üben</h4>
                <p className="text-sm text-[#4B5563]">Jeden Tag einen neuen Buchstaben lernen – nach 28 Tagen ist das Alphabet komplett!</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">🎧 Nasheeds hören</h4>
                <p className="text-sm text-[#4B5563]">Islamische Kinderlieder über Ramadan und Eid gemeinsam hören und mitsingen.</p>
              </div>
            </div>
          </section>

          <section id="gutes" className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">5. Gute Taten</h2>
            <div className="space-y-4">
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">💰 Spardose für Sadaqah</h4>
                <p className="text-sm text-[#4B5563]">Kinder sammeln im Ramadan Geld für einen guten Zweck und spenden es zu Eid.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">📝 Gute-Taten-Tagebuch</h4>
                <p className="text-sm text-[#4B5563]">Jeden Tag eine gute Tat dokumentieren und darüber sprechen.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">🎁 Nachbarn beschenken</h4>
                <p className="text-sm text-[#4B5563]">Gemeinsam Datteln oder Kekse an Nachbarn verteilen.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">🧸 Spielzeug spenden</h4>
                <p className="text-sm text-[#4B5563]">Alte Spielsachen aussortieren und an bedürftige Kinder verschenken.</p>
              </div>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">Fazit</h2>
            <p className="text-[#4B5563] leading-relaxed mb-4">Der Ramadan bietet unzählige Möglichkeiten, Kindern den Glauben näherzubringen – durch Spaß, Kreativität und gemeinsame Zeit. Diese Aktivitäten schaffen Erinnerungen, die ein Leben lang bleiben.</p>
            <p className="text-xl text-[#4A5D4F] font-medium">Ramadan Mubarak! 🌙</p>
          </section>

          <div className="bg-[#F5F5F0] rounded-2xl p-6 mb-8">
            <h3 className="font-serif text-lg font-medium text-[#2C332E] mb-4">Weitere Artikel</h3>
            <ul className="space-y-2">
              <li><Link to="/ratgeber/ramadan-kalender-selber-machen" className="text-[#4A5D4F] hover:underline">→ Ramadan Kalender selber machen</Link></li>
              <li><Link to="/ratgeber/islamische-buecher-kinder" className="text-[#4A5D4F] hover:underline">→ Islamische Bücher für Kinder</Link></li>
            </ul>
          </div>

          <div className="bg-[#4A5D4F] rounded-2xl p-8 text-center">
            <h3 className="font-serif text-2xl font-medium text-white mb-4">Kinderprodukte entdecken</h3>
            <Link to="/geschenke/kinder" className="inline-flex items-center gap-2 bg-white text-[#4A5D4F] px-8 py-3 rounded-full font-medium hover:bg-[#D4C5A9] transition-colors">Jetzt stöbern<Gift className="w-5 h-5" /></Link>
          </div>
        </div>
      </article>
    </main>
  );
}
